import { staticContentService } from '../localService';

import { ApplianceModel } from '~/core/models';

const sinksApi = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchInStoreSinks: builder.query<ApplianceModel[], { url: string }>({
      query: ({ url }) => ({
        url,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchInStoreSinksQuery } = sinksApi;
